import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import Layout from "./components/Layout";
import RomPad from "./pages/RomPad";
import AccountSettings from "./pages/AccountSettings";
import BlockTable from "./pages/BlockTable";

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<Navigate to="/rom-pad" replace />} />
            <Route path="/block-table" element={<BlockTable />} />
            <Route path="/rom-pad" element={<RomPad />} />
            <Route path="/account-settings" element={<AccountSettings />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
